<template>
  <div class="page">
    <ion-grid class="page-content">
      <ion-row class="row-divider"></ion-row>
      <ion-row class="rectangle">
        <ion-col>
          <ion-row>
            <ion-col class="col-padding">
              <ion-label class="light-text">Enter your registered mobile number</ion-label>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="col-padding">
              <ion-label class="border-text" position="stacked">
                Mobile Number
                <span class="required">*</span>
              </ion-label>
              <div class="border-line">
                <ion-input
                  type="tel"
                  class="form-input"
                  placeholder="Enter Mobile Number"
                  @input="mobile = $event.target.value"
                  :mobile="mobile"
                  maxLength="10"
                ></ion-input>
              </div>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col class="col-padding">
              <ion-label class="secondary-text">Answer Secret Question</ion-label>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="col-padding">
              <ion-label class="border-text" position="stacked">
                Secret Question
                <span class="required">*</span>
              </ion-label>
              <div class="border-line select-mobile">
                <ion-select
                  :value="question"
                  @ionChange="changeQues($event)"
                  placeholder="Select Question"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(question, index) in this.questions"
                    :key="index"
                    :value="question.code"
                  >{{question.question}}</ion-select-option>
                </ion-select>
              </div>
              <div class="border-line select-web">
                <select class="input-select" v-model="question" placeholder="Select Question">
                  <option
                    v-for="(question, index) in this.questions"
                    :key="index"
                    :value="question.code"
                  >{{question.question}}</option>
                </select>
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="col-padding">
              <ion-label class="border-text" position="stacked">
                Secret Answer
                <span class="required">*</span>
              </ion-label>
              <div v-if="question == 'D'">
                <div class="date-picker-box-rc datepicker-web">
                  <!-- Comment for Migration  -->
                  <!-- <datepicker
                    input-class="form-vue-picker"
                    placeholder="DD/MON/YYYY"
                    format="dd/MMM/yyyy"
                    v-model="answer"
                    :typeable="true"
                  ></datepicker> -->
                  <datepicker 
                    v-model="answer" 
                    inputFormat="dd/MMM/yyyy" 
                    class="form-vue-picker"
                    placeholder="DD/MON/YYYY" 
                    typeable=true 
                  />
                  <span class="custom-calendar-icon">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                </div>
                <div class="border-line datepicker-mobile">
                    <!-- <ion-datetime
                      class="form-picker"
                      placeholder="Select Date of birth"
                      displayFormat="YYYY, MM, DD"
                      :max="maxYear"
                      @ionChange="answer = $event.target.value"
                    ></ion-datetime> -->
                    <datepicker 
                      v-model="answer" 
                      inputFormat="dd/MMM/yyyy" 
                      class="form-picker"
                      placeholder="Select Date of birth" 
                    />
                    <span class="input-icon-calendar">
                      <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                </div>
              </div>
              <div class="border-line" v-if="question != 'D'">
                <ion-input
                  type="text"
                  class="form-input"
                  placeholder="Enter Secret Answer"
                  @input="answer = $event.target.value"
                ></ion-input>
              </div>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
        <!-- Corp -->
        <!-- <ion-row class="rectangle forgotForm">
          <ion-col>
            <ion-row>
              <ion-col class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Email
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    placeholder="Enter Email"
                    @input="mobile = $event.target.value"
                    :mobile="mobile"
                    maxLength="50"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row> -->
      <div text-center>
        <ion-row>
          <ion-col class="col-padding">
            <ion-button expand="block" class="btn-primary" @click="sendOTP">Generate OTP</ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="col-padding">
            <ion-button expand="block" class="btn-primary" @click="gotoLogin">Cancel</ion-button>
          </ion-col>
        </ion-row>
      </div>
    </ion-grid>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton } from "@ionic/vue";
import moment from "moment";
import { AuthenticationService } from "../../service/account/authenticator.service";
import { LocalStorage } from "../../data/localstorage";

import { ValidationUtils } from "../../util/validation-utils";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import datepicker from 'vue3-datepicker'
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
export default defineComponent ({
  name: 'forgotPassword',
  components: {
    datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton
  },
  data() {
      return {

      }
  },
  async mounted() {
      try {
      let questions = await new AuthenticationService().secretQuestions();
      this.questions = questions;
      } catch (error) {
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
  },
  data() {
    return {
      maxYear: moment()
      .add(-18, "year")
      .format(),
      mobile: "",
      questions: "",
      question: "",
      answer: ""
    };
  },
  methods: {
    changeQues(event) {
    this.question = event.target.value;
    this.answer = "";
    },
    async sendOTP() {
    try {
      if (
      typeof this.mobile === "undefined" ||
      this.mobile === null ||
      this.mobile === "" ||
      this.mobile.trim().length === 0
      ) {
      new ToastUtils().presentToast("Enter Mobile Number");
      // new ToastUtils().presentToast("Enter Email");
      } 
      // for corp
      // else if (new ValidationUtils().email(this.mobile) === false) {
      //   new ToastUtils().presentToast("Enter Valid Email");
      // }
      // for user
      else if (new ValidationUtils().mobile(this.mobile) === false) {
      new ToastUtils().presentToast("Enter Valid Mobile Number");
      }

      //For User
      else if (
      typeof this.question === "undefined" ||
      this.question === null ||
      this.question === ""
      ) {
      new ToastUtils().presentToast("Select Secret Question");
      } else if (
      typeof this.answer === "undefined" ||
      this.answer === null ||
      this.answer === "" ||
      (typeof this.answer === "string" && this.answer.trim().length === 0)
      ) {
      new ToastUtils().presentToast("Enter Secret Answer");
      } 
      
      else {
      let user;
      if (this.question === "D") {
        user = await new AuthenticationService().recoverPasswordOfUserWithMobileNoByDOB(
        this.mobile,
        new Date(this.answer)
        );
      } else if (this.question === "E") {
        if (new ValidationUtils().email(this.answer) === false) {
        new ToastUtils().presentToast("Enter Valid Email Address");
        } else {
        user = await new AuthenticationService().recoverPasswordOfUserWithMobileNoByEmail(
          this.mobile,
          this.answer
        );
        }
      } else {
        user = await new AuthenticationService().recoverPasswordOfUserWithoutMobileNoAndEmail(
          this.mobile,
          this.answer
        );
      }
      if (user) {
        new ToastUtils().presentToast("OTP sent to your mobile number.");
        new LocalStorage().user = user;
        new LocalStorage().mobile = this.mobile;
        this.$router.push("/passwordverification");
      }
      }
    } catch (error) {
      // let serviceError = tryParseServiceError(error);
      // new AlertUtils().presentAlert(serviceError ? serviceError : error);
      new ToastUtils().presentToast(error.response.data.errors[0].detail);
    }
    },
    gotoLogin() {
      this.$router.push("/login");
    }
  }
})
</script>

<style scoped>
@media (min-width: 768px) {
  .forgotForm {
    display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 120px;
  }
}
</style>